!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/Button")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/Button"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/Button")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (o, n) {
  return a = {}, r.m = i = {
    0: function (e, t) {
      e.exports = o;
    },
    10: function (e, t, o) {
      "use strict";

      o.d(t, "b", function () {
        return n;
      }), o.d(t, "a", function () {
        return r;
      });
      var n = function (t) {
          for (var e = arguments.length, o = Array(1 < e ? e - 1 : 0), n = 1; n < e; n++) o[n - 1] = arguments[n];
          return o.filter(Boolean).map(function (e) {
            return t[e];
          }).join(" ");
        },
        r = function () {
          for (var e = arguments.length, t = Array(e), o = 0; o < e; o++) t[o] = arguments[o];
          return t.filter(Boolean).join(" ");
        };
    },
    2: function (e, t, r) {
      "use strict";

      var o,
        n,
        c = function () {
          return o = void 0 === o ? !(!(window && document && document.all) || window.atob) : o;
        },
        i = (n = {}, function (e) {
          if (void 0 === n[e]) {
            var t = document.querySelector(e);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (e) {
              t = null;
            }
            n[e] = t;
          }
          return n[e];
        }),
        s = [];
      function l(e) {
        for (var t = -1, o = 0; o < s.length; o++) if (s[o].identifier === e) {
          t = o;
          break;
        }
        return t;
      }
      function p(e, t) {
        for (var o = {}, n = [], r = 0; r < e.length; r++) {
          var i = e[r],
            a = t.base ? i[0] + t.base : i[0],
            c = o[a] || 0,
            p = "".concat(a, " ").concat(c);
          o[a] = c + 1;
          c = l(p), i = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
          -1 !== c ? (s[c].references++, s[c].updater(i)) : s.push({
            identifier: p,
            updater: function (t, e) {
              var o, n, r;
              {
                var i;
                r = e.singleton ? (i = h++, o = m = m || d(e), n = f.bind(null, o, i, !1), f.bind(null, o, i, !0)) : (o = d(e), n = function (e, t, o) {
                  var n = o.css,
                    r = o.media,
                    o = o.sourceMap;
                  r ? e.setAttribute("media", r) : e.removeAttribute("media");
                  o && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */"));
                  if (e.styleSheet) e.styleSheet.cssText = n;else {
                    for (; e.firstChild;) e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(n));
                  }
                }.bind(null, o, e), function () {
                  !function (e) {
                    if (null === e.parentNode) return;
                    e.parentNode.removeChild(e);
                  }(o);
                });
              }
              return n(t), function (e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || n(t = e) : r();
              };
            }(i, t),
            references: 1
          }), n.push(p);
        }
        return n;
      }
      function d(e) {
        var t,
          o = document.createElement("style"),
          n = e.attributes || {};
        if (void 0 !== n.nonce || (t = r.nc) && (n.nonce = t), Object.keys(n).forEach(function (e) {
          o.setAttribute(e, n[e]);
        }), "function" == typeof e.insert) e.insert(o);else {
          e = i(e.insert || "head");
          if (!e) throw Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          e.appendChild(o);
        }
        return o;
      }
      var a,
        u = (a = [], function (e, t) {
          return a[e] = t, a.filter(Boolean).join("\n");
        });
      function f(e, t, o, n) {
        o = o ? "" : n.media ? "@media ".concat(n.media, " {").concat(n.css, "}") : n.css;
        e.styleSheet ? e.styleSheet.cssText = u(t, o) : (n = document.createTextNode(o), (o = e.childNodes)[t] && e.removeChild(o[t]), o.length ? e.insertBefore(n, o[t]) : e.appendChild(n));
      }
      var m = null,
        h = 0;
      e.exports = function (e, i) {
        (i = i || {}).singleton || "boolean" == typeof i.singleton || (i.singleton = c());
        var a = p(e = e || [], i);
        return function (e) {
          if ("[object Array]" === Object.prototype.toString.call(e = e || [])) {
            for (var t = 0; t < a.length; t++) {
              var o = l(a[t]);
              s[o].references--;
            }
            for (var e = p(e, i), n = 0; n < a.length; n++) {
              var r = l(a[n]);
              0 === s[r].references && (s[r].updater(), s.splice(r, 1));
            }
            a = e;
          }
        };
      };
    },
    211: function (e, t, o) {
      (t = e.exports = o(4)()).push([e.i, "._1LXdJ-2-0-721{margin:0 -34px;padding:0 34px}@media(max-width:448px){._1LXdJ-2-0-721{margin:0 -26px;padding:0 26px;margin:0 -16px;padding:0 16px}}._1LXdJ-2-0-721._21Bpm-2-0-721{background-color:#ffecc0}._1LXdJ-2-0-721.q_3Sg-2-0-721{background-color:#fff8e7}._1LXdJ-2-0-721._3j5UE-2-0-721{background-color:#f1f1f1}._1LXdJ-2-0-721:first-child{margin-top:-34px;padding-top:34px;border-top-left-radius:6px;border-top-right-radius:6px}._1LXdJ-2-0-721:last-child{margin-bottom:-34px;padding-bottom:34px}@media(max-width:646px){._1LXdJ-2-0-721:last-child{margin-bottom:-26px;padding-bottom:26px}}@media(max-width:448px){._1LXdJ-2-0-721:last-child{margin-bottom:-34px;padding-bottom:34px}}._15UXm-2-0-721{border-bottom-left-radius:6px;border-bottom-right-radius:6px}", ""]), t.locals = {
        "popup-section": "_1LXdJ-2-0-721",
        "orange-new-feature": "_21Bpm-2-0-721",
        "orange-light": "q_3Sg-2-0-721",
        gray: "_3j5UE-2-0-721",
        "border-bottom-radius": "_15UXm-2-0-721"
      };
    },
    212: function (e, t, o) {
      (t = e.exports = o(4)()).push([e.i, '._1Kfsp-2-0-721{position:fixed;left:0;top:0;right:0;bottom:0;z-index:99999;height:100%;width:100%;margin:0;padding:0;display:flex;align-items:center;justify-content:center;background-color:rgba(6,21,35,.8);font-family:Verdana,Dejavu Sans,Geneva,Tahoma,sans-serif}._2IY2U-2-0-721{background:none}.uaL73-2-0-721{overflow:auto;z-index:10;width:100%;max-height:100%;-webkit-overflow-scrolling:touch}.uaL73-2-0-721 ._2WZFc-2-0-721{position:absolute;right:30px;top:37px;z-index:1;cursor:pointer}@media(max-width:448px){.uaL73-2-0-721 ._2WZFc-2-0-721{right:14px}}@media(max-width:646px){.uaL73-2-0-721{height:100%}}._1i2Z5-2-0-721{font-family:Verdana,Dejavu Sans,Geneva,Tahoma,sans-serif;color:#39444f;text-align:left;font-stretch:normal;line-height:34px;letter-spacing:-.3px;font-size:26px;margin-bottom:18px;padding-right:52px}@media(max-width:646px){._1i2Z5-2-0-721{margin-bottom:8px}}@media(max-width:448px){._1i2Z5-2-0-721{margin-bottom:10px}}._3JvCe-2-0-721{padding:34px}@media(max-width:646px){._3JvCe-2-0-721{padding:34px 34px 26px}}@media(max-width:448px){._3JvCe-2-0-721{padding:34px 16px}}._17DU9-2-0-721{padding:34px 34px 26px}@media(max-width:448px){._17DU9-2-0-721{padding:34px 16px}}.y_9_S-2-0-721{border-radius:6px;box-shadow:0 2px 10px rgba(0,0,0,.85);background:#fff;margin:34px auto;width:100%;max-width:646px;position:relative}@media(max-width:646px){.y_9_S-2-0-721{display:flex;flex-direction:column;margin:auto;border-radius:0;min-height:100%}}._1hLPJ-2-0-721{max-width:448px}._28KsW-2-0-721{background-color:#f1f1f1;padding:34px;border-bottom-left-radius:6px;border-bottom-right-radius:6px}@media(max-width:646px){._28KsW-2-0-721{border-radius:0;padding-top:0;padding-bottom:44px;background-color:#fff;margin-top:auto}}@media(max-width:448px){._28KsW-2-0-721{text-align:center;padding:0 16px 34px}}._28KsW-2-0-721 .zi1xU-2-0-721{display:inline-flex;margin-right:16px}@media(max-width:448px){._28KsW-2-0-721 .zi1xU-2-0-721{margin-right:0;display:block}}._28KsW-2-0-721 .YpY-X-2-0-721{display:inline-flex}@media(max-width:448px){._28KsW-2-0-721 .YpY-X-2-0-721{display:block;margin-top:24px}}._28KsW-2-0-721 .YpY-X-2-0-721._1QFc5-2-0-721{opacity:.6;pointer-events:none}._28KsW-2-0-721 .YpY-X-2-0-721 ._1c46J-2-0-721{font-size:13px;border-bottom:1px dotted #478cc8;color:#478cc8;cursor:pointer;line-height:17px;text-decoration:none}._28KsW-2-0-721 .YpY-X-2-0-721 ._1c46J-2-0-721:hover{border-bottom:1px solid #478cc8;text-decoration:none}._2P3pC-2-0-721{padding-top:0;padding-bottom:44px;background-color:#fff}@media(max-width:448px){._2P3pC-2-0-721{padding:0 16px 34px}}._2WZFc-2-0-721{display:inline-block;position:relative;vertical-align:middle;width:28px;height:28px;border:0;background:none;color:transparent;outline:0}._2WZFc-2-0-721:after{transform:rotate(45deg)}._2WZFc-2-0-721:after,._2WZFc-2-0-721:before{content:"";position:absolute;border-top:4px solid #949a9f;width:36px;left:-4px;top:12px}._2WZFc-2-0-721:before{transform:rotate(-45deg)}._2WZFc-2-0-721:hover{color:transparent}._2WZFc-2-0-721:hover:after,._2WZFc-2-0-721:hover:before{border-color:#39444f}._3_RKH-2-0-721{margin-top:auto}.Z0Vx--2-0-721{z-index:999991;background-color:rgba(6,21,35,.5)}._1JLvu-2-0-721,.Z0Vx--2-0-721{position:absolute;left:0;top:0;right:0;bottom:0;height:100%;width:100%}._1JLvu-2-0-721{border-radius:5px;overflow:hidden}@media(max-width:646px){._1JLvu-2-0-721{border-radius:0}}.MAdwy-2-0-721{position:relative;z-index:999992}@media(max-width:646px){.MAdwy-2-0-721{min-height:100%}}', ""]), t.locals = {
        "popup-container": "_1Kfsp-2-0-721",
        "no-backdrop": "_2IY2U-2-0-721",
        "ati-core-popup": "uaL73-2-0-721",
        "ati-core-close-button": "_2WZFc-2-0-721",
        "ati-core-popup-header": "_1i2Z5-2-0-721",
        "ati-core-text-content": "_3JvCe-2-0-721",
        "ati-core-text-content--white": "_17DU9-2-0-721",
        "ati-core-popup-content": "y_9_S-2-0-721",
        "ati-core-popup-content--small": "_1hLPJ-2-0-721",
        "ati-core-popup-actions": "_28KsW-2-0-721",
        "ati-core-popup-main-action": "zi1xU-2-0-721",
        "ati-core-popup-alternate-action": "YpY-X-2-0-721",
        disabled: "_1QFc5-2-0-721",
        "action-link": "_1c46J-2-0-721",
        "ati-core-popup-actions--white": "_2P3pC-2-0-721",
        "confirmation-component-wrapper": "_3_RKH-2-0-721",
        "warning-overlay": "Z0Vx--2-0-721",
        "warning-wrapper": "_1JLvu-2-0-721",
        "warning-container": "MAdwy-2-0-721"
      };
    },
    25: function (e, t) {
      e.exports = n;
    },
    4: function (e, t) {
      e.exports = function () {
        var a = [];
        return a.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var o = this[t];
            o[2] ? e.push("@media " + o[2] + "{" + o[1] + "}") : e.push(o[1]);
          }
          return e.join("");
        }, a.i = function (e, t) {
          "string" == typeof e && (e = [[null, e, ""]]);
          for (var o = {}, n = 0; n < this.length; n++) {
            var r = this[n][0];
            "number" == typeof r && (o[r] = !0);
          }
          for (n = 0; n < e.length; n++) {
            var i = e[n];
            "number" == typeof i[0] && o[i[0]] || (t && !i[2] ? i[2] = t : t && (i[2] = "(" + i[2] + ") and (" + t + ")"), a.push(i));
          }
        }, a;
      };
    },
    543: function (e, t, o) {
      "use strict";

      o.r(t), o.d(t, "default", function () {
        return g;
      });
      var i = o(0),
        m = o.n(i),
        n = o(25),
        a = o.n(n),
        c = o(10),
        p = o(83),
        r = o(2),
        t = o.n(r),
        n = o(211),
        r = o.n(n),
        n = {
          insert: "head",
          singleton: !1
        },
        s = (t()(r.a, n), r.a.locals || {}),
        n = function (e) {
          var t = e.className,
            o = e.color,
            n = e.children,
            e = e.isBorderBottomRadius;
          return m.a.createElement("div", {
            className: Object(c.a)(s["popup-section"], s[o], e && s["border-bottom-radius"], t)
          }, n);
        },
        r = o(212),
        o = o.n(r),
        r = {
          insert: "head",
          singleton: !1
        },
        h = (t()(o.a, r), o.a.locals || {});
      function l(e) {
        return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function d(e, t) {
        for (var o = 0; o < t.length; o++) {
          var n = t[o];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      function u(e, t) {
        return (u = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function f(o) {
        var n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var e,
            t = x(o);
          return e = n ? (e = x(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" !== l(e) && "function" != typeof e ? function (e) {
            if (void 0 !== e) return e;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(t) : e;
        };
      }
      function x(e) {
        return (x = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      o = function () {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && u(e, t);
        }(r, i["PureComponent"]);
        var e,
          t,
          o,
          n = f(r);
        function r() {
          var i;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r);
          for (var e = arguments.length, t = Array(e), o = 0; o < e; o++) t[o] = arguments[o];
          return (i = n.call.apply(n, [this].concat(t))).scrollingTop = !1, i.scrollPosition = {
            x: 0,
            y: 0
          }, i.warningContainer = m.a.createRef(), i.core = m.a.createRef(), i.container = m.a.createRef(), i.outerClick = function (e) {
            var t = e.target,
              o = i.core.current,
              n = i.container.current,
              o = "mousedown" === e.type && i.props.closeOnOverlayClick && (t === n || t === o),
              e = "keyup" === e.type && i.props.closeOnEscape && 27 === e.which;
            (o || e) && i.handleClose();
          }, i.handleClose = function () {
            i.props.onClose(i.props.id);
          }, i.handleWarningOverlayClick = function () {
            !1 !== i.props.closeOnOverlayClick && i.handleClose();
          }, i.renderFooter = function () {
            var e = i.props,
              t = e.primaryAction,
              o = e.alternateAction,
              n = e.whiteActionArea,
              r = e.isPrimaryActionLoading,
              e = e.footer;
            return (t || o || e) && m.a.createElement("div", {
              className: Object(c.b)(h, "ati-core-popup-actions", n && "ati-core-popup-actions--white")
            }, e, !e && m.a.createElement("div", {
              className: h["ati-core-popup-main-action"]
            }, m.a.createElement(a.a, {
              onClick: t.action,
              className: h["ati-core-popup-button"],
              isLoading: r,
              mobile: !0,
              disabled: t.disabled
            }, t.name)), o && !e && m.a.createElement("div", {
              className: Object(c.b)(h, "ati-core-popup-alternate-action", o.disabled && "disabled")
            }, m.a.createElement("span", {
              className: h["action-link"],
              onClick: o.action,
              role: "button",
              tabIndex: -1
            }, o.name)));
          }, i.handleScrollToWarning = function () {
            var e = i.props,
              t = e.showWarning,
              o = e.warningComponent,
              n = i.core.current,
              e = i.warningContainer.current,
              e = e && n.scrollTop > e.offsetHeight;
            t && o && e && !i.scrollingTop && (i.scrollingTop = !0, Object(p.a)({
              from: n.scrollTop,
              to: 0,
              duration: 200,
              progress: function (e) {
                n.scrollTop = e;
              },
              onCompleted: function () {
                i.scrollingTop = !1;
              }
            }));
          }, i;
        }
        return e = r, (t = [{
          key: "componentDidMount",
          value: function () {
            this.props.ignoreBodyOverflow || (document.body.style.overflow = "hidden"), this.props.fixedBodyPosition && (this.props.restorePosition && (this.scrollPosition = {
              x: window.pageXOffset,
              y: window.pageYOffset
            }), document.body.style.position = "fixed"), document.addEventListener("mousedown", this.outerClick), document.addEventListener("keyup", this.outerClick);
          }
        }, {
          key: "componentDidUpdate",
          value: function () {
            this.handleScrollToWarning();
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            document.removeEventListener("mousedown", this.outerClick), document.removeEventListener("keyup", this.outerClick), this.props.ignoreBodyOverflow || (document.body.style.overflow = ""), this.props.fixedBodyPosition && (document.body.style.position = "", this.props.restorePosition && window.scrollTo(this.scrollPosition.x, this.scrollPosition.y));
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props,
              t = e.title,
              o = e.children,
              n = e.warningComponent,
              r = e.showWarning,
              i = e.small,
              a = e.contentClassName,
              c = e.className,
              p = e.noBackdrop,
              s = e.whiteActionArea,
              l = e.hideCloseButton,
              d = e.showConfirmation,
              u = e.confirmationComponent,
              f = e.dataName,
              e = e.coreClassName;
            return m.a.createElement("div", {
              className: [h["popup-container"], c || "", p && h["no-backdrop"]].join(" "),
              ref: this.container,
              "data-name": f
            }, m.a.createElement("div", {
              className: h["ati-core-popup"],
              ref: this.core
            }, m.a.createElement("div", {
              className: [h["ati-core-popup-content"], i ? h["ati-core-popup-content--small"] : "", a || ""].join(" ")
            }, r && !!n && m.a.createElement(m.a.Fragment, null, m.a.createElement("div", {
              role: "presentation",
              className: h["warning-overlay"],
              onClick: this.handleWarningOverlayClick
            }), m.a.createElement("div", {
              className: h["warning-wrapper"]
            }, m.a.createElement("div", {
              className: h["warning-container"],
              ref: this.warningContainer
            }, n))), !l && m.a.createElement("button", {
              className: h["ati-core-close-button"],
              onClick: this.handleClose
            }), m.a.createElement("div", {
              className: [h["ati-core-text-content"], s ? h["ati-core-text-content--white"] : "", e || ""].join(" ")
            }, !!t && m.a.createElement("div", {
              className: h["ati-core-popup-header"]
            }, t), o), d && u ? m.a.createElement("div", {
              className: h["confirmation-component-wrapper"]
            }, u) : this.renderFooter())));
          }
        }]) && d(e.prototype, t), o && d(e, o), r;
      }();
      o.Section = n, o.defaultProps = {
        whiteActionArea: !1,
        small: !1,
        showWarning: !1,
        confirmationComponent: !1
      };
      var g = o;
    },
    83: function (e, t, o) {
      "use strict";

      t.a = function (e) {
        var o = e.progress,
          t = e.from,
          n = void 0 === t ? 0 : t,
          t = e.to,
          r = void 0 === t ? 0 : t,
          t = e.duration,
          i = void 0 === t ? 300 : t,
          a = e.onCompleted,
          c = performance.now(),
          e = function e(t) {
            t = (t - c) / i;
            0 <= (t = 1 < t ? 1 : t) && o(n < r ? (r - n) * t + n : n - (n - r) * t), t < 1 ? requestAnimationFrame(e) : a && a();
          };
        requestAnimationFrame(e);
      };
    }
  }, r.c = a, r.d = function (e, t, o) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (t, e) {
    if (1 & e && (t = r(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var o = Object.create(null);
    if (r.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) r.d(o, n, function (e) {
      return t[e];
    }.bind(null, n));
    return o;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 543);
  function r(e) {
    if (a[e]) return a[e].exports;
    var t = a[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, r), t.l = !0, t.exports;
  }
  var i, a;
});